import { render, staticRenderFns } from "./CarGroups.vue?vue&type=template&id=745dfcca"
import script from "./CarGroups.vue?vue&type=script&lang=js"
export * from "./CarGroups.vue?vue&type=script&lang=js"
import style0 from "./CarGroups.vue?vue&type=style&index=0&id=745dfcca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports